import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import {
  Chip,
  FormControl,
  Popover,
  Typography,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  Icon,
} from '@material-ui/core'
import { previewChannel } from 'app/constants/previewCompose'

const RadioSelector = (props) => {
  const { name, value, options, onChange, disabled } = props
  const { formatMessage } = useIntl()
  const [isOpen, setIsOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const getSelectedOption = useCallback(() => {
    if (!value) return null
    return options.find((o) => o.id === value) || previewChannel.homeFeed
  }, [options, value])

  const handleLabel = useCallback(() => {
    const sel = getSelectedOption()
    return formatMessage({ id: sel?.labelId })
  }, [getSelectedOption])

  const handleOnClose = useCallback(() => {
    setIsOpen(false)
    setAnchorEl(null)
  }, [])

  return (
    <>
      {!options?.length ? null : (
        <>
          <Chip
            className="bg-primary-200 text-blue-950"
            label={
              <Typography className="flex items-center">
                <strong className="mx-3">{handleLabel()}</strong>
                <Icon fontSize="small" className="text-primary">
                  {isOpen ? 'expand_less' : 'expand_more'}
                </Icon>
              </Typography>
            }
            onClick={(event) => {
              setIsOpen(true)
              setAnchorEl(event.currentTarget)
            }}
            disabled={disabled}
          />

          <Popover
            id={`${name}-radio-popover`}
            open={isOpen}
            anchorEl={anchorEl}
            onClose={handleOnClose}
            className="w-full rounded-8"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          >
            <Grid item xs={12} md={3}>
              <FormControl
                name={name}
                component="fieldset"
                className="p-5"
                disabled={disabled}
              >
                <Typography className="text-14 text-blue-950 font-medium">
                  MessageSpring App
                </Typography>
                <RadioGroup
                  value={value}
                  onChange={(e) => {
                    onChange(e.target.value)
                  }}
                >
                  {options.map((opt, idx) => {
                    return (
                      <div
                        key={idx}
                        className="whitespace-nowrap text-primary text-14 font-normal"
                      >
                        <FormControlLabel
                          value={opt.id}
                          control={<Radio color="primary" />}
                          label={formatMessage({ id: opt.labelId })}
                        />
                      </div>
                    )
                  })}
                </RadioGroup>
              </FormControl>
            </Grid>
          </Popover>
        </>
      )}
    </>
  )
}

const optionType = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  labelId: PropTypes.string,
}

RadioSelector.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  value: PropTypes.number,
  options: PropTypes.arrayOf(PropTypes.shape(optionType)).isRequired,
}

export default RadioSelector
